import React, { memo, useMemo } from 'react'

import i18n from '@batical/i18n'
import { useContextValue } from '@batical/reducer/src'
import { CalculCodeStateKeys } from '@batical/types/src'
import { Box } from '@mui/material'

import { ResultTextStyled, ResultTextValue, ResultTextUnit, ViewLineResult } from './LineStyleComponent'
import { batikalColor } from '../Colors'

export type ResultTextProps = {
  title?: string
  calculCode: CalculCodeStateKeys
  variableName: string
  invalidated?: boolean
}
const ResultText = ({ title, calculCode, variableName }: ResultTextProps) => {
  const value = useContextValue(variableName, calculCode)[0]
  const text = useMemo(() => {
    let tex = ''
    if (title) {
      tex = i18n.t(title)
    } else {
      tex = i18n.t(`${calculCode}_${variableName}`)
    }

    return tex
  }, [calculCode, title, variableName])
  return <ResultTextManual title={text} value={value} />
}

export type ResultTextManualProps = {
  title: string
  value: string
  first?: boolean
  last?: boolean
  invalidated?: boolean
}

export const ResultTextManual = ({ title, value, invalidated = false }: ResultTextManualProps) => {
  return (
    <ViewLineResult justifyContent="space-between" alignItems="center" sx={{ backgroundColor: batikalColor }}>
      <Box sx={{ flex: 1 }}>
        <ResultTextStyled>{title}</ResultTextStyled>
      </Box>
      {invalidated && (
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
          <ResultTextValue>{i18n.t('invalidatedCalcul')}</ResultTextValue>
        </Box>
      )}
      {!invalidated && (
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
          <ResultTextUnit>{value}</ResultTextUnit>
        </Box>
      )}
    </ViewLineResult>
  )
}

export default memo(ResultText)
